import { useTranslation } from "react-i18next";
import { Plus, Trash2 } from "lucide-react";
import { NeuButton, NeuInput, NeuSelect } from "../../components/neu/Neu";
import { localName } from "../../lib/localName";

export const EntryLines = ({ lines, accounts, onChange }) => {
  const { t, i18n } = useTranslation();
  const ar = i18n.language === "ar";
  const set = (index, key, value) =>
    onChange(lines.map((line, i) => (i === index ? { ...line, [key]: value } : line)));

  return (
    <div className="grid gap-2" data-testid="entry-lines-editor">
      {lines.map((line, index) => (
        <div key={index} className="grid gap-2 sm:grid-cols-[2fr_1fr_1fr_auto]">
          <NeuSelect
            data-testid={`line-account-${index}`}
            value={line.account_code}
            onChange={(e) => set(index, "account_code", e.target.value)}
          >
            <option value="">{t("acct.pickAccount")}</option>
            {accounts.map((a) => (
              <option key={a.code} value={a.code}>
                {a.code} — {ar ? localName(a) : a.name}
              </option>
            ))}
          </NeuSelect>
          <NeuInput
            data-testid={`line-debit-${index}`}
            type="number"
            step="0.01"
            placeholder={t("acct.debit")}
            value={line.debit}
            onChange={(e) => set(index, "debit", e.target.value)}
          />
          <NeuInput
            data-testid={`line-credit-${index}`}
            type="number"
            step="0.01"
            placeholder={t("acct.credit")}
            value={line.credit}
            onChange={(e) => set(index, "credit", e.target.value)}
          />
          <NeuButton
            variant="danger"
            className="px-3 py-2"
            data-testid={`line-remove-${index}`}
            onClick={() => onChange(lines.filter((_, i) => i !== index))}
          >
            <Trash2 className="h-4 w-4" />
          </NeuButton>
        </div>
      ))}
      <NeuButton
        className="w-fit px-3 py-2 text-xs"
        data-testid="line-add"
        onClick={() => onChange([...lines, { account_code: "", debit: "", credit: "" }])}
      >
        <Plus className="h-3.5 w-3.5" /> {t("acct.addLine")}
      </NeuButton>
    </div>
  );
};
